import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

export const creditCardBenefits: Record<
    Partial<CreditCardProductCategory>,
    string[]
> = {
    ['BalanceTransfer']: [
        'Cut interest payments and clear debt faster',
        'Save hundreds or thousands of pounds',
        'Get up more than two years interest-free',
        'FCA regulated',
    ],

    ['BestCards']: [
        'Borrow up to your credit limit and repay monthly',
        'Different cards for different needs',
        'Section 75 protection on purchases over £100',
        'Build your credit score by using a card responsibly',
    ],

    ['Cashback']: [
        'Earn money when you spend',
        'Get a percentage of your purchases back as cash',
        'Simple and flexible - no points to track and exchange',
        'Protection on eligible purchases over £100',
    ],

    ['Combined']: [
        'Shift debt and make new purchases on one card',
        'Get 0% interest on transfers and purchases',
        'Manage your money with just one simple monthly payment',
        'Extra protection on eligible purchases over £100',
    ],

    ['PoorCredit']: [
        'Borrow money and rebuild your credit score',
        'A stepping stone to better financial products',
        'No interest if you pay in full each month',
        'FCA regulated',
    ],

    ['Purchase']: [
        'Spread costs without paying interest',
        'Make bigger purchases more affordable',
        'Get breathing space and pay back what you owe over more time',
        'FCA regulated',
    ],

    ['Rewards']: [
        'Earn money or points on your spending',
        'Get real value form everyday purchases',
        'Extra protection on eligible purchases over £100',
        'Access to exclusive perks and benefits',
    ],

    ['Travel']: [
        'No or low foreign transaction fees when you spend abroad',
        'Better exchange rates than your regular card',
        'Section 75 protection on eligible purchases over £100',
        'Some cards offer fee-free cash withdrawals',
    ],
}
